export const NotFoundPage = () => {
    return (
        <>
            <div className="container-xxl vh-100 container-p-y" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <div className="misc-wrapper text-center">
                    <h1 className="mb-2 mx-2 text-center" style={{ lineHeight: "6rem", fontSize: "6rem" }}>404</h1>
                    <h4 className="mb-2 mx-2">No se encontro la pagina! 🤔</h4>
                    <p className="mb-6 mx-2">Verifique con su proveedor o intente mas tarde.</p>
                    <div className="text-center">
                        <a href="/" className="btn btn-primary">Ir al inicio</a>
                    </div>

                </div>
            </div>

        </>
    )
}